const DISCLAIMER_INFORMING_ITEM_KEY = 'disclaimer-informing-ids';

const getDisclaimerInformingChatIds = () => {
  const chatIdsClosedDisclaimer = localStorage.getItem(
    DISCLAIMER_INFORMING_ITEM_KEY,
  );

  return chatIdsClosedDisclaimer ? JSON.parse(chatIdsClosedDisclaimer) : null;
};

export const closeDisclaimerInforming = chatId => {
  try {
    const closedDisclaimerChatIds = getDisclaimerInformingChatIds();
    const updatesIdsData = closedDisclaimerChatIds
      ? [...closedDisclaimerChatIds, chatId]
      : [chatId];

    localStorage.setItem(
      DISCLAIMER_INFORMING_ITEM_KEY,
      JSON.stringify(updatesIdsData),
    );
  } catch (e) {
    return null;
  }
};

export const clearDisclaimerInformingIds = () => {
  try {
    localStorage.removeItem(DISCLAIMER_INFORMING_ITEM_KEY);
  } catch (e) {
    return null;
  }
};

export const isClosedDisclaimerInforming = chatId => {
  const closedDisclaimerChatIds = getDisclaimerInformingChatIds();

  return closedDisclaimerChatIds
    ? closedDisclaimerChatIds.includes(chatId)
    : false;
};



// WEBPACK FOOTER //
// ./src/utils/localStorage/disclaimerInformingStorage.js